import axiosInstance from "./axiosInstance";

export const getPlanDetails = async () => {
  try {
    const response = await axiosInstance.get("/public/planDetails", {
      headers: { authType: "PreLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch plan details");
  }
};

export const getPlanDetailsById = async (id) => {
  try {
    const response = await axiosInstance.get(`/planDetailsFetch/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch plan detail");
  }
};

export const createPlanDetails = async (planData) => {
  try {
    const response = await axiosInstance.post("/planDetails", planData, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to create plan details");
  }
};

export const updatePlanDetails = async (id, planData) => {
  try {
    const response = await axiosInstance.put(`/planDetails/${id}`, planData, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to update plan details");
  }
};

export const deletePlanDetails = async (id) => {
  try {
    const response = await axiosInstance.delete(`/planDetailsdel/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to delete plan details");
  }
};

export const getPricing = async () => {
  try {
    const response = await axiosInstance.get("/planDetails", {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch pricing");
  }
};